import { onCleanup } from "solid-js";

export const useOnClickOutside = (ref: HTMLElement, callback: () => void) => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      ref &&
      !ref.contains(event.target as Node) &&
      !event.composedPath().includes(ref)
    ) {
      callback();
    }
  };
  document.addEventListener("click", handleClickOutside);
  onCleanup(() => {
    document.removeEventListener("click", handleClickOutside);
  });
};
